import { Component, input } from "@angular/core";
import { NgClass, NgStyle } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "portal-wizard-steps",
  templateUrl: "./wizard-steps.component.html",
  styleUrls: ["./wizard-steps.component.scss"],
  standalone: true,
  imports: [NgClass, NgStyle, TranslatePipe],
})
export class WizardStepsComponent {
  /** Collection of steps */
  readonly steps = input<string[]>([]);
  /** Current step index, start at 0 */
  readonly currentStep = input<number>(0);
  /** Use localization (string must be defined in json) */
  readonly useLocalization = input<boolean>(false);
  readonly activeColor = input<string>("#d63517");
  readonly doneColor = input<string>("#d63517");

  /**
   * Get class style for current index
   * @param index
   */
  getStepClass(index: number): string {
    let classString = "";
    if (this.currentStep() === index) {
      classString = "active";
    }
    if (index < this.currentStep()) {
      classString = "done";
    }
    return classString;
  }

  /**
   * Get style for current index
   * @param index
   */
  getStepStyle(index: number): object {
    let style = {};
    if (this.currentStep() === index) {
      style = { "background-color": this.activeColor() };
    }
    if (index < this.currentStep()) {
      style = { "background-color": this.doneColor() };
    }
    return style;
  }

  /**
   * Get style for right bar
   * @param index
   */
  getBarRightStyle(index: number): object {
    let style = {};
    if (index < this.currentStep()) {
      style = { "border-top": `2px solid ${this.doneColor()}` };
    }
    return style;
  }

  /**
   * Get style for left bar
   * @param index
   */
  getBarLeftStyle(index: number): object {
    let style = {};
    if (this.currentStep() === index || index < this.currentStep()) {
      style = { "border-top": `2px solid ${this.doneColor()}` };
    }
    return style;
  }
}
